"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerProvider = void 0;
var React = require("react");
var PropTypes = require("prop-types");
/**
 * Provider component that injects a runtime `LoggerFactory`
 * function into the child context of the component tree.
 */
var LoggerProvider = /** @class */ (function (_super) {
    __extends(LoggerProvider, _super);
    function LoggerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoggerProvider.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    LoggerProvider.prototype.getChildContext = function () {
        return {
            factory: this.props.factory,
        };
    };
    LoggerProvider.contextTypes = {
        factory: PropTypes.func,
    };
    LoggerProvider.childContextTypes = {
        factory: PropTypes.func,
    };
    return LoggerProvider;
}(React.Component));
exports.LoggerProvider = LoggerProvider;
//# sourceMappingURL=logger-provider.js.map